import useFetchEffect from '@/hooks/useFetchEffect';
import {
  fetchNotifications,
  fetchPropertiesDocumentStatistics,
  fetchPropertiesValueEstimates,
  getPropertyPriceHistories,
} from '@/api/properties';
import { fetchPropertyCompanyStats } from '@/api/propertyowners';
import { connect } from 'react-redux';
import {
  acSetFetchingNotifications,
  acSetFetchingNotificationsError,
  acSetUserNotifications,
} from '@/store/actions/notifications';
import { sGetUserNotifications } from '@/store/reducers/notifications';
import {
  acSetPropertyCompanyStats,
  acSetPropertyDocumentStatistics,
  acSetPropertyValueEstimates,
  acSetPropertyValueIncreases,
} from '@/store/actions/properties';
import {
  sGetOwnedProperties,
  sGetPropertyByBoligmappaNumber,
  sGetPropertyCompanyStats,
  sGetPropertyDocumentStatistics,
  sGetPropertyValueEstimates,
  sGetPropertyValueIncreases,
  sGetSharedPrivatelyProperties,
} from '@/store/reducers/properties';
import { useFetchDocuments } from '@/api/hooks';
import { sGetUser } from '@/store/reducers/auth';

const PropertyDataProvider = ({
  children,
  boligmappaNumber,
  authUser,
  ownedProperties,
  sharedProperties,
  userNotifications,
  setFetchingNotifications,
  setFetchingNotificationsError,
  propertyValueIncreases,
  propertyValueEstimates,
  propertyDocumentStatistics,
  propertyCompanyStats,
  getPropertyByBoligmappaNumber,
  setPropertyValueIncreases,
  setPropertyValueEstimates,
  setPropertyDocumentStatistics,
  setPropertyCompanyStats,
  setUserNotifications,
}) => {
  useFetchDocuments(getPropertyByBoligmappaNumber(boligmappaNumber));

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onFetchStart: () => setFetchingNotifications(true),
    onFetchComplete: () => setFetchingNotifications(false),
    onError: (error) => setFetchingNotificationsError(error),
    dependencies: [authUser],
    onSuccess: (data) => setUserNotifications(data.notifications),
    conditionFunction: () => !userNotifications && authUser?.id,
    apiFetchFunction: () => fetchNotifications(authUser?.id),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyValueIncreases(data),
    conditionFunction: () => !propertyValueIncreases,
    apiFetchFunction: () => getPropertyPriceHistories(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyValueEstimates(data),
    conditionFunction: () => !propertyValueEstimates,
    apiFetchFunction: () => fetchPropertiesValueEstimates(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    dependencies: [ownedProperties, sharedProperties],
    onSuccess: (data) => setPropertyDocumentStatistics(data),
    conditionFunction: () =>
      (ownedProperties?.length || sharedProperties?.length) &&
      !propertyDocumentStatistics,
    apiFetchFunction: () =>
      fetchPropertiesDocumentStatistics(
        ownedProperties.map((el) => el.boligmappaNumber),
        sharedProperties.map((el) => el.boligmappaNumber)
      ),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyCompanyStats(data),
    conditionFunction: () => !propertyCompanyStats,
    apiFetchFunction: () => fetchPropertyCompanyStats(),
  });
  return children;
};

const mapStateToProps = (state) => ({
  authUser: sGetUser(state),
  ownedProperties: sGetOwnedProperties(state),
  sharedProperties: sGetSharedPrivatelyProperties(state),
  userNotifications: sGetUserNotifications(state),
  propertyValueIncreases: sGetPropertyValueIncreases(state),
  propertyValueEstimates: sGetPropertyValueEstimates(state),
  propertyDocumentStatistics: sGetPropertyDocumentStatistics(state),
  propertyCompanyStats: sGetPropertyCompanyStats(state),
  getPropertyByBoligmappaNumber: (boligmappaNumber) =>
    sGetPropertyByBoligmappaNumber(state, boligmappaNumber),
});
const mapDispatchToProps = (dispatch) => ({
  setUserNotifications: (data) => dispatch(acSetUserNotifications(data)),
  setFetchingNotifications: (fetching) =>
    dispatch(acSetFetchingNotifications(fetching)),
  setFetchingNotificationsError: (error) =>
    dispatch(acSetFetchingNotificationsError(error)),
  setPropertyValueIncreases: (data) =>
    dispatch(acSetPropertyValueIncreases(data)),
  setPropertyValueEstimates: (data) =>
    dispatch(acSetPropertyValueEstimates(data)),
  setPropertyDocumentStatistics: (data) =>
    dispatch(acSetPropertyDocumentStatistics(data)),
  setPropertyCompanyStats: (data) => dispatch(acSetPropertyCompanyStats(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyDataProvider);
